import { FormInput } from '@noissue-ui-kit/oldBranding/formInput'
import debounce from 'lodash.debounce'
import { useCallback, useEffect, useState } from 'react'
import { HiSearch } from 'react-icons/hi'
import { TColor } from '../unifiedColorPicker.types'

type TListColorPickerProps = {
  colorsList: TColor[]
  showSearchBox?: boolean
  onChange?: (color: TColor) => void
  activeColor: TColor
  className?: string
  wrapperHeight: number
}

const SEARCH_INPUT_HEIGHT = 45
const SELECT_COLOR_BTN_HEIGHT = 70

export const ListColorPicker = ({
  colorsList,
  showSearchBox,
  onChange,
  activeColor,
  className = '',
  wrapperHeight,
}: TListColorPickerProps) => {
  const [colors, setColors] = useState(colorsList || [])
  const [searchColor, setSearchColor] = useState('')
  const [listHeight, setListHeight] = useState(200)

  const handleClick = (color: TColor) => {
    if (typeof onChange === 'function') {
      onChange(color)
    }
  }

  const doSearchColor = (colorText: string) => {
    const filterdPantoneColors = colors.filter(
      (color) =>
        color.label.toLowerCase().includes(colorText) ||
        color.value.toLowerCase().includes(colorText)
    )
    setColors(filterdPantoneColors)
  }

  const handleSearchColor = useCallback(debounce(doSearchColor, 300), [])

  const handleSearchChange = (e) => {
    const colorText = e.target.value
    setSearchColor(colorText)
    handleSearchColor(colorText.toLowerCase())
  }

  useEffect(() => {
    if (wrapperHeight) {
      setListHeight(
        wrapperHeight -
          (showSearchBox ? SEARCH_INPUT_HEIGHT : 0) -
          SELECT_COLOR_BTN_HEIGHT
      )
    }
  }, [wrapperHeight, showSearchBox])

  return (
    <div className="w-full h-full max-h-full font-mori">
      {showSearchBox && (
        <div className="relative">
          <FormInput
            type="text"
            name="search"
            placeholder="Search color"
            IconBefore={() => <HiSearch />}
            initialValue={searchColor}
            onChange={handleSearchChange}
            className="w-full text-2xl !h-16 outline-0 mb-2 bg-black-10 !focus:border-acai"
            inputClassName="bg-black-10"
          />
        </div>
      )}
      <div
        className={`flex flex-col max-h-[200px] scroll-smooth overflow-y-auto hover:overflow-y-scroll text-core-purple-90 ${className} scrollbar-thin`}
        style={{ maxHeight: listHeight + 'px' }}
      >
        {colors?.length > 0 ? (
          colors.map((color) => {
            return (
              <div
                key={color.label}
                onClick={() => handleClick(color)}
                className={`flex items-center gap-[12px] p-[4px] text-lg ${
                  activeColor?.label === color.label ||
                  activeColor?.value === color?.value
                    ? 'bg-core-purple-10'
                    : ''
                } hover:bg-core-purple-10 border-b border-b-core-grey-40`}
              >
                <span
                  className="inline-block w-[30px] h-[30px] rounded-full border-2 border-core-grey-20 scale-100 duration-300"
                  style={{ backgroundColor: color.value }}
                ></span>
                <span>{color.label}</span>
              </div>
            )
          })
        ) : (
          <span className="inline-block w-full text-center p-[4px] text-xl text-acai">
            Not found
          </span>
        )}
      </div>
    </div>
  )
}
